<template>
  <ContentWrapper>
    <v-card tile>
      <v-card-title>Wir feiern! 50 Jahre ETC!</v-card-title>
      <v-card-text>
        <div class="media">
          <div class="video">
            <iframe class="embedded-video" src="https://www.youtube.com/embed/la4W_JsYjA8?si=_SJ1Gv6l1lP9nqK6"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </ContentWrapper>
</template>
<script>
import ContentWrapper from "../components/ContentWrapper";

export default {
  components: {
    ContentWrapper,
  },
  mounted() {
    this.$store.commit('SET_TITLE', '50 Jahre');
  },
  data: function () {
    return {
      images: Array.from({length: 98}, (_, i) => `/img/anniversary/${i + 1}.jpeg`),
      index: null
    };
  },
}
</script>

<style scoped>
.media {
  display: flex;
  gap: 2rem;
  flex-direction: column;
  align-items: center;
}

.video {
  display: flex;
  justify-content: center;
  width: 100%;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin: 1rem;
}

.video {
  display: flex;
  justify-content: center;
  width: 536px;
  height: 315px;
}

.embedded-video {
  width: 536px;
  height: 315px;
}

@media (max-width: 640px) {
  .video {
    width: 350px;
    height: 197px;
  }

  .embedded-video {
    width: 350px;
    height: 197px;
  }
}


@media (min-width: 641px) {
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    margin: 1rem;
  }
}
</style>
